export default __webpack_public_path__ + "aeb0a6b7dc79115d9212b9445349024f.wav";